import { ActionTypes } from "../../constants/ActionTypes";
import { IUploadFileReducer } from "../../interfaces";
// import { IUploadFile } from '../../interfaces';
const INIT_STATE: IUploadFileReducer = {
  bodyUploadSuccess: false,
  bodyDeletedSuccess: false,
  content: [],
};

export default (state = INIT_STATE, action: any) => {
  switch (action.type) {
    case ActionTypes.CLEAR_UPLOAD_FILE: {
      return {
        ...state,
        bodyUploadSuccess: false,
        bodyDeletedSuccess: false,
        content: [],
      };
    }

    case ActionTypes.UPLOAD_FILE_SUCCESS: {
      return {
        ...state,
        bodyUploadSuccess: action.payload.bodyUploadSuccess,
        bodyDeletedSuccess: false,
        content: state.content.concat(action.payload.content),
      };
    }

    case ActionTypes.DELETE_FILE_SUCCESS: {
      return {
        ...state,
        bodyDeletedSuccess: action.payload.bodyDeletedSuccess,
        bodyUploadSuccess: false,
      };
    }

    default:
      return state;
  }
};
